import styles from "./FooterTop.module.css";
import CelebrateImg from "../../../assets/images/CelebrateImg.png";
import { Link } from "react-router-dom";

export default function FooterTop() {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.footerTopOuter}>
          <div className={styles.left}>
            <h3>
              Celebrate Academic
              <span> Excellence Nominate Today</span>
            </h3>
            <p>
              Whether you're an institution, a peer, or a student, you can help
              us spotlight excellence in academia. Submit your nominations and
              help honor those shaping the future of higher education.
            </p>

            <div className={styles.buttonSection}>
              <Link className={styles.orangeButton} to="/">
                Submit Nomination
              </Link>
              <Link className={styles.blueButton} to="/">
                Download Guidelines
              </Link>
            </div>
          </div>
          <div className={styles.right}>
            <img src={CelebrateImg} alt="CelebrateImg" />
          </div>
        </div>
      </div>
    </footer>
  );
}
